<template>
  <div class="h">
    <!-- GQ -->
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      :immediate-check="false"
      finished-text="没有更多了"
      :offset="100"
      @load="onLoad"
    >
      <div
        class="send"
        v-for="(one,index) in sendList"
        :key="index"
        @click="goParticular(one.orderId)"
        slot="default"
      >
        <p>
          <span class="left">订单编号：{{one.orderCode}}</span>
          <span class="right">{{status | statusDt}}</span>
        </p>
        <p>
          <span class="price">配送地址：{{one.deliveryName}}</span>
        </p>
        <p class="time">
          <span>配送日期：{{one.deliveryTime | dateFil}}</span>
        </p>
        <!-- 订单列表 -->
        <div >
          <van-row
            type="flex"
            class="order"
            v-for="(two,index) in one.children.slice(0,3)"
            :key="index"
          >
            <van-col span="16">
              <div class="van-ellipsis">{{two.goodsName}}</div>
            </van-col>
            <van-col span="6" class="weight">￥{{two.confirmPrice}}/{{two.saleUnitLabel}}</van-col>
            <van-col span="2" class="amount">x{{two.orderQty}}</van-col>
          </van-row>
        </div>
        <div v-if="one.children.length > 3">...</div>
        <p class="total">
          <span class="ty-left">共{{one.children.length}}个商品</span>
          <span class="ty-center">￥{{allPrice(one)}}</span>
          <span class="ty-right">合计：</span>
        </p>
        <div class="line" v-if="status != 100"></div>
        <van-row type="flex" justify="end">
          <van-button
            v-if="status== 10"
            round
            type="info"
            size="mini"
            plain
            class="change"
            color="#74B42B"
            @click.stop="revision(one.orderId)"
          >修改</van-button>
          <van-button
            v-if="status== 30"
            round
            type="info"
            size="mini"
            plain
            color="#74B42B"
            @click.stop="checking(one.orderId)"
          >确认对账</van-button>
        </van-row>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  created() {
    if (this.status) {
      this.getSendList();
    }
  },
  props: ["status", "urlT"],
  computed: {
    // 计算价格
    allPrice() {
      return one => {
        const res = this.sendList.find(item => {
          return item.orderId === one.orderId;
        });
        const ress = res.children.map(item => {
          return item.confirmPrice * (item.deliveryQty - item.diffQty);
        });
        const price = ress.reduce((price, val) => {
          price += val;
          return price;
        }, 0);
        const number = String(price).indexOf(".");

        if (number == -1) {
          //没有小数点
          return price;
        } else {
          return String(price).length - number > 2 ? price.toFixed(2) : price;
        }
      };
    }
  },
  data() {
    return {
      customerId: "", // 客户id
      sendList: [], // send列表
      //GQ
      loading: false,
      finished: false,
      current: 1,
      size: 10,
      total: 0,
      error: false
    };
  },
  methods: {
    //GQ : 更新下一页数据
    onLoad() {
      // 数据全部加载完成
      if (this.sendList.length >= this.total) {
        this.finished = true;
        return;
      }
      this.$axios
        .post(
          `/trade/tradeOrder/page?current=${this.current}&size=${this.size}&descs=order_id`,
          {
            customerId: this.customerId,
            needDtls: 1,
            goodsKindValue:0,
            status: this.status
          }
        )
        .then(res => {
          if (res.data.code != 0 && res.data.data == null) {
            this.error = true;
          }
          // this.current = res.data.data.current + 1;
          this.sendList = res.data.data.records;
          res.data.data.records.forEach(v => {
            this.sendList.push(v);
          });
          this.loading = false;
          this.$emit("listt", this.sendList);
        });
    },
    // 获取列表
    async getSendList() {
      const res = await this.$axios.get("/customer/customer/info");
      const Cid = res.data.data.customerId;
      this.customerId = Cid;
      const ress = await this.$axios.post(
        `/trade/tradeOrder/page?current=${this.current}&size=${this.size}&descs=order_id`,
        {
          customerId: this.customerId,
          needDtls: 1,
          goodsKindValue:0,
          status: this.status
        }
      );
      // this.sendList = ress.data.data.records.reverse();
      this.sendList = ress.data.data.records;
      this.total = ress.data.data.total;
      this.current = ress.data.data.current + 1;
      this.$emit("listt", this.sendList);
    },
    // 修改
    revision(orderId) {
      this.$router.push({ path: "/revision", query: { orderId: orderId } });
    },
    // 确认对账
    checking(orderId) {
      this.$dialog
        .confirm({
          title: "提示",
          message: "您确定要确认对账么？",
          confirmButtonColor: "#74b42b"
        })
        .then(() => {
          this.$axios.get(`/trade/tradeOrder/confirm/${orderId}`).then(res => {
            if (res.data.code == 0) {
              this.$toast("对账成功");
              this.goParticular(orderId);
            }
          });
        });
    },
    goParticular(orderId) {
      this.$router.push({ path: this.urlT, query: { orderId } });
    }
  }
};
</script>

<style scoped>
.send {
  width: 90%;
  background-color: #fff;
  margin: 6px auto;
  border-radius: 10px;
  padding: 10px 10px 8px;
   box-shadow: 0px 0px 4px 1px rgba(153, 153, 153, 0.1);
  font-size: 12px;
}
.right {
  float: right;
  font-size: 12px;
  color: #74b42b;
}
.left {
  font-size: 14px;
  font-weight: 700;
}
.time {
  margin-bottom: 5px;
}
.order {
  font-size: 14px;
  line-height: 22px;
}
.weight {
  color: #f5a623;
}
.total {
  margin-top: 10px;
}
.ty-center,
.ty-right {
  float: right;
}
.ty-center {
  float: right;
  color: #f5a623;
}
.line {
  width: 100%;
  height: 1px;
  background-color: #dddddd;
  margin-bottom: 5px;
  margin-top: 5px;
}
.van-button {
  padding: 1px 2px 2px 2px;
  line-height: 16px;
}
.amount {
  text-align: right;
}
.van-button[data-v-e6f2db3a] {
  padding: 1px 6px 2px 6px;
}
.change {
  padding: 1px 18px 2px 18px !important;
}
</style>